<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "ContactForm" });
import { Form } from "../../../../components/index.js";
import { createEventDispatcher } from "svelte";
import * as API from "../../services/api.js";
export let contact = { type: "contact" };
export let action = "create";
export let organizationKey;
export let beforeSave = () => {
};
const dispatch = createEventDispatcher();
let formElement = null;
const onSave = (response) => {
    if ("code" in response) {
        return;
    }
    dispatch("save", response);
};
const onSubmit = async () => {
    await beforeSave();
    if (action === "update") {
        onSave(await API.updateContact({ contactKey: contact._.key }, contact));
        return;
    }
    onSave(await API.createContact({ ...contact, organizationKey }));
};
export const submit = async () => {
    if (formElement === null) {
        return;
    }
    await formElement.submit();
};
export const isValid = () => {
    if (formElement === null) {
        return false;
    }
    return formElement.isValid();
};
</script>

<Form { onSubmit } id = { `${ action }-contact` } bind:this = { formElement }>

    <slot>
        <h3>{ action } Contact</h3>
        <pre>{ JSON.stringify(contact, null, 2) }</pre>
    </slot>

    <svelte:fragment slot = 'footer'><slot name = 'footer' /></svelte:fragment>

</Form>